export const LAYOUT_TYPE_VERTICAL_LEFT = "VERTICAL_LEFT";
export const LAYOUT_TYPE_HORIZONTAL = "HORIZONTAL";
export const LAYOUT_TYPE_HORIZONTAL_STYLE_2 = "HORIZONTAL_STYLE_2";
export const LAYOUT_TYPE_FILTERS_SIDEBAR = "FILTERS_SIDEBAR";

export const SUPPORT_STATUS_FULL = "SUPPORT_FULL";
export const SUPPORT_STATUS_COLLECTION = "SUPPORT_COLLECTION";
export const SUPPORT_STATUS_SEARCH = "SUPPORT_SEARCH";